import React from "react";
import { GOALS_SETTINGS_PATH, pastGoalsPath } from "../../Settings/constants";
import { PlanFooterNote, PlanLink } from "../styles";
import { PlanGoalRow } from "./PlanGoalRow";
import { PlanJustEnded } from "./PlanJustEnded";
import {
  PlanEmptyGoals,
  PlanGoalsBlock,
  PlanGoalsList,
  PlanGoalsTitle,
} from "./styles";
import { PlanGoalsProps } from "./types";

export const PlanGoalsSection: React.FC<PlanGoalsProps> = ({
  rows,
  justEndedGoals,
  isLoading,
  isError,
  isEmpty,
  pastGoalCount,
}) => {
  const hasPastGoals = pastGoalCount > 0;
  const emptyText = hasPastGoals ? "No active goals." : "No goals yet.";
  const pastGoalsNoun = pastGoalCount === 1 ? "goal" : "goals";
  const pastGoalsLabel = `${pastGoalCount} past ${pastGoalsNoun} →`;

  return (
    <PlanGoalsBlock aria-labelledby="plan-goals-title">
      <PlanGoalsTitle id="plan-goals-title">Goals</PlanGoalsTitle>
      {isLoading && (
        <PlanEmptyGoals role="status">Loading goals…</PlanEmptyGoals>
      )}
      {isError && (
        <PlanEmptyGoals role="status">
          <span>Some goals could not be loaded.</span>
          <PlanLink href={GOALS_SETTINGS_PATH}>Review in Settings →</PlanLink>
        </PlanEmptyGoals>
      )}
      {isEmpty && (
        <PlanEmptyGoals>
          <span>{emptyText}</span>
          <PlanLink href={GOALS_SETTINGS_PATH}>
            Create one in Settings →
          </PlanLink>
        </PlanEmptyGoals>
      )}
      {rows.length > 0 && (
        <PlanGoalsList aria-label="Goal progress">
          {rows.map(({ key, goal, subtitle }) => (
            <PlanGoalRow key={key} goal={goal} subtitle={subtitle} />
          ))}
        </PlanGoalsList>
      )}
      <PlanJustEnded goals={justEndedGoals} />
      {hasPastGoals && (
        <PlanFooterNote>
          <PlanLink href={pastGoalsPath}>{pastGoalsLabel}</PlanLink>
        </PlanFooterNote>
      )}
    </PlanGoalsBlock>
  );
};
